import { createSelector } from "reselect"
import * as Models from "../../../models/index"
import _ from "lodash"

const getUserPwdValidationResult = (state: Models.StoreState) => {
    return state.pwdValidate.userPwdValidationResult;
}

const getOldPwdValidationResult = (state: Models.StoreState) => {
    return state.pwdValidate.oldPwdValidationResult;
}

const getSecretAnswers = (state: Models.StoreState) => state.pwdSecurity.answers

export const validateResult = createSelector(getUserPwdValidationResult, getOldPwdValidationResult, (getUserPwdValidationResult, getOldPwdValidationResult) => {
    let result = getUserPwdValidationResult.slice();
    result.push(getOldPwdValidationResult);
    return result;
})

export const validateSecretAnswers = createSelector(getSecretAnswers, (secretAnswers) => {
    return !_.some(secretAnswers, answer => !answer.answerText || !answer.questionId);
})